import React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { SignUp } from '../../actions';
import { FormInput } from '../../Interfaces/Interfaces';
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2';

const CreateAccount = (): JSX.Element => {
  
  const [input, setInput] = useState<FormInput>({
    name: '',
    lastName: '',
    email: '',
    tel: '',
    password:'',
    dni:'',
    vinculacion:''
  });

  type HandleForm = (e: React.ChangeEvent<HTMLInputElement>) => void;

  const [errors, setErrors] = useState<{ [key: string]: string }>({})
 
  

  const validate = (input: FormInput): { [key: string]: string } => {
    let errors: { [key: string]: string } = {};

    // Validar los campos requeridos
    if (!input.name) {
      errors.name = 'El nombre es requerido';
    }

    if (!input.lastName) {
      errors.lastName = 'El apellido es requerido';
    }

    if (!input.email) {
      errors.email = 'El correo electrónico es requerido';
    }

    if (!input.tel) {
      errors.tel = 'El teléfono es requerido';
    }

    if (!input.password) {
      errors.password = 'La contraseña es requerida';
    }

    if (!input.dni) {
      errors.dni = 'El DNI es requerido';
    }
    
    if (!input.vinculacion) {
      errors.vinculacion = 'El codigo de vinculacion es requerido';
    }
    return errors;
  }

 


 
  const handleChange: HandleForm = (e) => {
    const { name, value } = e.target;
    setInput((prevInput: FormInput) => ({
      ...prevInput,
      [name]: value,
    }));

    setErrors(validate({
      ...input,
      [e.target.name]: e.target.value
    }));

    console.log(errors)
   
  };

  const dispatch = useDispatch();
  
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    if (Object.keys(errors).length === 0) {
      try {
        await dispatch(SignUp(input));
        await  Swal.fire({
          title: 'Su cuenta a sido creada con exito',
          icon: 'success',
          timer: 1000,
          timerProgressBar: true,
          showConfirmButton: false
        })
        window.location.href = '/'
      } catch (error:any) {
        
        console.log(error);
      }
} 
  }

  return (
    <div className='w-auto bg-bgSteps  sm:w-screen flex flex-col justify-center items-center '>
 
   <h1 className='sm:mt-4 mb-4 font-roboto text-[28px]'>Crear cuenta</h1>

    <div className="w-4/5 sm:w-2/5 py-8 bg-white">
      
      <form className='flex flex-col justify-center items-center font-roboto' onSubmit={handleSubmit}>
       
       
       
        <div className="flex flex-col w-2/3 space-y-1">
          <span className="text-[18px]">Nombre</span>
          <input
            onChange={handleChange}
            name="name"
            type="text"
            placeholder="Nombre"
            className="border h-10 p-2 rounded"
          />
          {errors.name && (<p className='text-[10px] text-red-500'>{errors.name}</p>)}
        </div>
        
       
       
        <div className="flex flex-col w-2/3 space-y-1 mt-4">
          <span className="text-[18px]">Apellido</span>
          <input
            onChange={handleChange}
            name="lastName"
            type="text"
            placeholder="Apellido"
            className="border h-10 p-2  rounded"
          />
        {errors.lastName && (<p className='text-[10px] text-red-500'>{errors.lastName}</p>)}
        </div>

        <div className="flex flex-col w-2/3 space-y-1 mt-4">
          <span className="text-[18px]">Email</span>
          <input
            onChange={handleChange}
            name="email"
            type="text"
            placeholder="Email"
            className="border h-10 p-2 rounded"
          />
          {errors.email && (<p className='text-[10px] text-red-500'>{errors.email}</p>)}
        </div>

        <div className="flex flex-col w-2/3 space-y-1 mt-4">
          <span className="text-[18px]">Telefono</span>
          <input
            onChange={handleChange}
            name="tel"
            type="text"
            placeholder="Tel"
            className="border h-10 p-2 rounded"
          />
          {errors.tel && (<p className='text-[10px] text-red-500'>{errors.tel}</p>)}
        </div>

        <div className="flex flex-col w-2/3 space-y-1 mt-4">
          <span className="text-[18px]">Contraseña</span>
          <input
            onChange={handleChange}
            name="password"
            type="password"
            placeholder="Contraseña"
            className="border h-10 p-2 rounded"
          />          
          {errors.password && (<p className='text-[10px] text-red-500'>{errors.password}</p>)}
        </div>

        <div className="flex flex-col w-2/3 space-y-1 mt-4">
          <span className="text-[18px]">DNI</span>
          <input
            onChange={handleChange}
            name="dni"
            type="text"
            placeholder="DNI"
            className="border h-10 p-2 rounded"
          />
          {errors.dni && (<p className='text-[10px] text-red-500'>{errors.dni}</p>)}
         </div>
        
         <div className="flex flex-col w-2/3 space-y-1 mt-4">
          <span className="text-[18px]">Codigo de Vinculacion</span>
          <input
            onChange={handleChange}
            name="vinculacion"
            type="text"
            placeholder="Codigo de vinculacion..."
            className="border h-10 p-2 rounded"
            />
            {errors.vinculacion && (<p className='text-[10px] text-red-500'>{errors.vinculacion}</p>)}
         </div> 

        <div className='flex flex-col justify-center items-center'>
        <button disabled={Object.keys(errors).length > 0} className={Object.keys(errors).length > 0 ? 'border p-2 w-full mt-8 rounded bg-gray-300 cursor-not-allowed text-white' : 'border p-2 w-full mt-8 rounded bg-background_home text-white'}>
          Crear Cuenta
        </button>
        
        <Link to="/login">
        <button className="text-md text-blue-600">¿Ya tienes cuenta? Inicia sesion</button>
        </Link>
        
        </div>
      
      </form>
    </div>
    </div>
  );
};

export default CreateAccount;